import { AREAS, DISTRICTS } from '@propertypal/shared/src/constants/housePrices';
import React, { Dispatch, FunctionComponent } from 'react';
import { useTheme } from 'styled-components';
import HorizontalDivider from '../divider/HorizontalDivider';
import SelectInput, { Option } from '../inputs/SelectInput';
import TextInput from '../inputs/TextInput';
import { MidHeading } from '../typography';
import { Container, Content } from './MarketTrendsPicker.style';

interface Props {
  electoralArea: string;
  setElectoralArea: Dispatch<string>;
  councilArea: string;
  setCouncilArea: Dispatch<string>;
  outcode: string;
  setOutcode: Dispatch<string>;
}

const mapLabel = (option: { id: string; name: string; district?: string }) => ({
  label: option.name,
  value: option.id,
});

const noOption: Option = { label: '-- None --', value: '' };

const MarketTrendsPicker: FunctionComponent<Props> = (props) => {
  const theme = useTheme();
  const { electoralArea, setElectoralArea } = props;
  const districtOptions = [noOption, ...DISTRICTS.map(mapLabel)];
  const areaOptions = [noOption, ...AREAS.filter((area) => area.district === props.councilArea).map(mapLabel)];

  return (
    <Container>
      <MidHeading fontSize={22} mb={35} fontWeight="normal" color={theme.white}>
        Find local property prices in your area
      </MidHeading>
      <Content>
        <SelectInput
          id="councilArea"
          ariaLabel="Filter by Council Area"
          options={districtOptions}
          label="Filter by Council Area"
          value={props.councilArea}
          onChange={(area) => {
            props.setCouncilArea(area);
            setElectoralArea('');
            props.setElectoralArea('');
          }}
          clearable
          placeholder="Select a Council Area"
          labelStyle={{ color: theme.white }}
          testID="councilArea"
        />

        <SelectInput
          id="electoralArea"
          ariaLabel="Filter by Electoral Area"
          options={areaOptions}
          label="Filter by Electoral Area"
          value={electoralArea}
          onChange={props.setElectoralArea}
          clearable
          disabled={props.councilArea === ''}
          placeholder="Select an Electoral Area"
          labelStyle={{ color: theme.white }}
          testID="electoralArea"
        />

        <HorizontalDivider text="or" dividerColor={theme.white} color={theme.white} />

        <TextInput
          label="Filter by Postcode"
          name="outcode"
          value={props.outcode}
          onValueChange={props.setOutcode}
          placeholder="Enter Postcode"
          testID="outcodeInput"
        />
      </Content>
    </Container>
  );
};

export default MarketTrendsPicker;
